export const RayCodeConstant = {
	GET_RAYCODELIST: 'GET_RAYCODELIST',
	GET_RAYCODE: 'GET_RAYCODE',
	CREATE_RAYCODE: 'CREATE_RAYCODE',
	UPDATE_RAYCODE: 'UPDATE_RAYCODE',
	DELETE_RAYCODE: 'DELETE_RAYCODE',
	ADDUPDATE: 'RC_ADDUPDATE',
    LOADING: 'RC_LOADING',
    LOADED: 'RC_LOADED',
};